module.exports = __webpack_public_path__ + "static/media/reply.129134cd.svg";